<script setup lang="ts">
import { Combobox } from '@ark-ui/vue'
import { computed, inject } from 'vue'
import UiIcon from './UiIcon.vue'
import UiAvatar from './UiAvatar.vue'
import type { ComboboxItemData } from './types/combobox'

export interface UiComboboxItemProps {
    item: ComboboxItemData
    image?: string
    label: string
    value: string
    rounded?: boolean
    showIndicator?: boolean
    showImage?: boolean
    initials?: string
}

const props = withDefaults(defineProps<UiComboboxItemProps>(), {
    rounded: false,
    showIndicator: true,
})

const groupShowImage = inject<boolean | undefined>('groupShowImage', undefined)
const shouldShowAvatar = computed(() => {
    if (props.showImage === false || (props.showImage === undefined && groupShowImage === false)) {
        return false
    }
    if (props.image !== undefined) {
        return true
    }
    if (props.showImage === true || groupShowImage === true) {
        return true
    }
    return false
})

</script>

<template>
    <Combobox.Item 
        :item="props.item" 
        class="flex items-center justify-between py-2 px-4 cursor-pointer hover:bg-se-gray-100 data-[highlighted]:bg-se-gray-100"
    >
        <div class="flex items-center gap-2 flex-1 min-w-0">
            <UiAvatar
                v-if="shouldShowAvatar"
                :url="props.image"
                :initials="props.initials"
                size="xxs"
            />
            <div class="flex flex-col min-w-0 flex-1">
                <Combobox.ItemText class="truncate" :title="props.label">{{ props.label }}</Combobox.ItemText>
                <span v-if="item.description" class="text-sm text-se-gray-500 truncate" :title="item.description">
                    {{ item.description }}
                </span>
            </div>
        </div>
        <div v-if="props.showIndicator" class="flex items-center ml-2">
            <Combobox.ItemIndicator>
                <div class="inline-flex items-center justify-center w-4 h-4 rounded border border-se-secondary-dark bg-se-secondary-dark text-se-white">
                    <UiIcon name="check" class="w-3 h-3 text-se-white" />
                </div>
            </Combobox.ItemIndicator>
        </div>
    </Combobox.Item>
</template>

